import AppSettingPage from '../app-setting/AppSettingPage';
import AxleBuilderPage from '../master-data/axle-builder/AxleBuilderPage';
import BatteryManagement from '../report/BatteryManagement';
import BusinessTypePage from '../master-data/business-type/BusinessTypePage';
import ChargingManagement from '../report/ChargingManagement';
import ConstructionTypePage from '../tyre-management-system/master-data/construction-type/ConstructionTypePage';
import DailyFuelSummaryPage from '../daily-fuel-summary/DailyFuelSummaryPage';
import DashboardHeader from '../dashboard/DashboardHeader';
import DataReportsPage from '../report/DataReportsPage';
import DriverLicensePage from '../license/driver-license/DriverLicensePage';
import DriverPage from '../master-data/driver/MasterDriverPage';
import DriverScoreCalculatePage from '../driver-management/reportV2/DriverScoreCalculatePage';
import DriverScorePeriodicPage from '../driver-management/DriverScorePeriodicPage';
import DriverScoreSettingPage from '../driver-management/DriverScoreSettingPage';
import HeaderFuelPrice from '../master-data/master-fuel-price/HeaderFuelPrice';
import HistoryDownloadVideoPage from '../video-monitoring/live-streaming/HistoryDownloadVideoPage';
import HistoryVideoPage from '../video-monitoring/live-streaming/HistoryVideoPage';
import LiveStreamingPage from '../video-monitoring/live-streaming/LiveStreamingPage';
import ManufacturePage from '../tyre-management-system/master-data/manufacture/ManufacturePage';
import Map from '../map-tracking/Map';
import MasterAreaPage from '../master-data/working-area/MasterAreaPage';
import MasterBrandPage from '../tyre-management-system/master-data/brand/MasterBrandPage';
import MasterCompanyPage from '../master-data/company/MasterCompanyPage';
import MasterCountryPage from '../master-data/country/MasterCountryPage';
import MasterCustomerPage from '../master-data/customer/MasterCustomerPage';
import MasterDriverLicensePage from '../master-data/driver-license/MasterDriverLicense';
import MasterFuelTypePage from '../master-data/fuel-type/MasterFuelTypePage';
import MasterGeofenceLibraryPage from '../master-data/geofence-list/GeofenceLibrary';
import MasterJetty from '../master-data/master-jetty/MasterJettyPage';
import MasterMenuPage from '../master-data/menu/MasterMenuPage';
import MasterPitPage from '../master-data/master-pit/MasterPitPage';
import MasterRolePage from '../master-data/master-role/MasterRolePage';
import MasterRoutePage from '../master-data/master-route/MasterRoutePage';
import MasterSizePage from '../tyre-management-system/master-data/size/MasterSizePage';
import MasterUserPage from '../master-data/user-and-role/MasterUserPage';
import MasterVehicleLicensePage from '../master-data/vehicle-license/VehicleLicensePage';
import MasterVehiclePage from '../master-data/vehicle/MasterVehiclePage';
import MasterVtdsPage from '../master-data/master-vtds/MasterVtdsPage';
import PackageMenuPage from '../master-data/package-menu/PackageMenuPage';
import ProfilePage from '../profile/ProfilePage';
import ReportAllSensorPage from '../report/ReportAllSensorPage';
import ReportFatiguePage from '../video-monitoring/report-fatigue/ReportFatiguePage';
import ReportPage from '../report/ReportPage';
import ReportSensorPage from '../report/ReportSensorPage';
import ReportSpeedByRitase from '../report/ReportSpeedByRitase';
import ReportWaypointPage from '../report/ReportWaypointPage';
import ServiceReminder from '../vehicle-maintenance/preventive-maintenance/service-reminder/ServiceReminder';
import ServiceTypePage from '../vehicle-maintenance/service-type/ServiceTypePage';
import SetDriverPage from '../master-data/driver/set-driver/SetDriverPage';
import SpecificationPage from '../tyre-management-system/master-data/specification/SpecificationPage';
import TireCyclePage from '../tyre-management-system/tire-operation/tire-cycle/TireCyclePage';
import TireDamagePage from '../tyre-management-system/master-data/damage/TireDamagePage';
import TireHistoricalPage from '../tyre-management-system/report/historical/TireHistoricalPage';
import TireInventoryPage from '../tyre-management-system/tire-operation/TireInventoryPage';
import TirePerformancePage from '../tyre-management-system/report/performance/TirePerformancePage';
import TireReceivingPage from '../tyre-management-system/tire-operation/TireReceivingPage';
import TireRepairScrapPage from '../tyre-management-system/tire-operation/tire-repair-scrap/TireRepairScrapPage';
import UserActivityHistoryPage from '../user-activity-history/UserActivityHistoryPage';
import UserActivityLogPage from '../user-activity-log/UserActivityLogPage';
import VehicleFuelHistoryPage from '../vehicle-fuel-history/VehicleFuelHistory';
import VehicleFuelSummaryPage from '../vehicle-fuel-summary/VehicleFuelSummary';
import VehicleLicensePage from '../license/vehicle-license/VehicleLicensePage';
import VehicleTypePage from '../master-data/vehicle-type/VehicleTypePage';
import VendorPage from '../master-data/vendor/VendorPage';
import WarehousePage from '../tyre-management-system/master-data/warehouse/WarehousePage';
import WorkOrderPage from '../vehicle-maintenance/preventive-maintenance/work-order/WorkOrderPage';
import WorkshopPage from '../vehicle-maintenance/workshop/WorkshopPage';

const modulesMap = {
  'app-setting': AppSettingPage,
  'axle-builder': AxleBuilderPage,
  'battery-management': BatteryManagement,
  'business-type': BusinessTypePage,
  'charging-management': ChargingManagement,
  'construction-type': ConstructionTypePage,
  customer: MasterCustomerPage,
  'daily-fuel-summary': DailyFuelSummaryPage,
  dashboard: DashboardHeader,
  'dashboard-asset': DashboardHeader,
  'dashboard-expense': DashboardHeader,
  'dashboard-revenue': DashboardHeader,
  'dashboard-vehicle': DashboardHeader,
  'data-reports': DataReportsPage,
  'driver-license-reminder': DriverLicensePage,
  'driver-performance': DriverScoreCalculatePage,
  'driver-score-periodic': DriverScorePeriodicPage,
  'driver-score-setting': DriverScoreSettingPage,
  'fuel-type': MasterFuelTypePage,
  'history-download-video': HistoryDownloadVideoPage,
  'history-video': HistoryVideoPage,
  'live-streaming': LiveStreamingPage,
  manufacture: ManufacturePage,
  'maps-monitoring': Map,
  'master-area': MasterAreaPage,
  'master-company': MasterCompanyPage,
  'master-country': MasterCountryPage,
  'master-driver': DriverPage,
  'master-driver-license': MasterDriverLicensePage,
  'master-fuel-price': HeaderFuelPrice,
  'master-geofence-library': MasterGeofenceLibraryPage,
  'master-gps': MasterVtdsPage,
  'master-jetty': MasterJetty,
  'master-menu': MasterMenuPage,
  'master-pit': MasterPitPage,
  'master-route': MasterRoutePage,
  'master-user': MasterUserPage,
  'master-vehicle': MasterVehiclePage,
  'master-vehicle-license': MasterVehicleLicensePage,
  'master-vendor': VendorPage,
  'package-menu': PackageMenuPage,
  'performance-tire': TirePerformancePage,
  profile: ProfilePage,
  report: ReportPage,
  'report-all-sensor': ReportAllSensorPage,
  'report-catalog': ReportPage,
  'report-fatigue': ReportFatiguePage,
  'report-sensor': ReportSensorPage,
  'report-speed-by-ritase': ReportSpeedByRitase,
  'report-tire-history': TireHistoricalPage,
  'report-waypoint': ReportWaypointPage,
  reporting: ReportPage,
  'service-reminder': ServiceReminder,
  'service-type': ServiceTypePage,
  'setting-score': DriverScoreSettingPage,
  'settings-driver': SetDriverPage,
  'tire-brand': MasterBrandPage,
  'tire-cycle': TireCyclePage,
  'tire-damage': TireDamagePage,
  'tire-inventory': TireInventoryPage,
  'tire-receiving': TireReceivingPage,
  'tire-repair-scrap': TireRepairScrapPage,
  'tire-size': MasterSizePage,
  'tire-specification': SpecificationPage,
  'user-activity-history': UserActivityHistoryPage,
  'user-activity-log': UserActivityLogPage,
  'user-management': MasterRolePage,
  'vehicle-fuel-history': VehicleFuelHistoryPage,
  'vehicle-fuel-summary': VehicleFuelSummaryPage,
  'vehicle-license-reminder': VehicleLicensePage,
  'vehicle-type': VehicleTypePage,
  vendor: VendorPage,
  warehouse: WarehousePage,
  'work-order': WorkOrderPage,
  workshop: WorkshopPage
};

export default modulesMap;
